import { Component, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Proposal from "@/pages/Proposal";
import PortalDemo from "@/pages/PortalDemo";
import MockupHome from "@/pages/MockupHome";
import MockupProduct from "@/pages/MockupProduct";
import Letter from "@/pages/Letter";

class ErrorBoundary extends Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-bone text-navy flex items-center justify-center p-8">
          <div className="max-w-md text-center space-y-4">
            <p className="font-mono text-xs tracking-[0.3em] text-ember uppercase">Something broke</p>
            <h1 className="font-body font-semibold text-2xl">This section failed to render.</h1>
            <button onClick={() => window.location.reload()} data-testid="error-reload-btn"
              className="bg-ember text-white font-semibold px-6 py-3 rounded-md">Reload</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<><Nav /><Proposal /></>} />
          <Route path="/demo" element={<PortalDemo />} />
          <Route path="/mockup/home" element={<MockupHome />} />
          <Route path="/mockup/product" element={<MockupProduct />} />
          <Route path="/letter" element={<Letter />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="light" />
    </ErrorBoundary>
  );
}

export default App;
